import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Message } from '../Message';
import { SubmissionError } from 'redux-form'

import { PageTitle } from '../PageTitle';
import { EventConfigurationsService } from "../../services";
import EventConfigurationForm from "./event_configuration_form";
import i18next from "i18next";

@connect(state => {
  return {
    me: state.user.me
  }
})
class EventConfigurationAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alertConfiguration: null,
      localErrorMessage: null,
      alertConfigurationSaved: false
    };
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
        <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }
    return null;
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  handleSubmit(alertConfigurationData) {
    // Drop alertConfigurationActions without complete info
    const errors = {};
    const alertConfigurationActionsArrayErrors = [];
    if (alertConfigurationData.alertConfigurationActions.length === 0) {
      this.setState({
        localErrorMessage: i18next.t('messages.at-least-one-condition'),
        alertConfigurationSaved: false
      });
      return;
    }
    alertConfigurationData.alertConfigurationActions.forEach((alertConfigurationAction, alertIndex) => {
      const alertConfigurationActionsErrors = {};

      if (!alertConfigurationAction || !alertConfigurationAction.deviceGroup) {
        alertConfigurationActionsErrors.deviceGroup = i18next.t('messages.please-select-originating-from');
        alertConfigurationActionsArrayErrors[alertIndex] = alertConfigurationActionsErrors;
      }
    });

    if(alertConfigurationActionsArrayErrors.length) {
      errors.alertConfigurationActions = alertConfigurationActionsArrayErrors;
      throw new SubmissionError(errors);
    }

    const alertConfiguration = {
      enterprise: { id: this.props.me.enterprise.id },
      name: alertConfigurationData.name,
      description: alertConfigurationData.description,
      alertConfigurationStatus: alertConfigurationData.status ? { id: alertConfigurationData.status.value} : null,
      alertConfigurationActions: alertConfigurationData.alertConfigurationActions.map(alertConfigurationAction => {
        return {
          deviceGroup: { id: alertConfigurationAction.deviceGroup.deviceGroup.id },
          duration: parseFloat(alertConfigurationAction.duration) * 60,
          alertLevel: { id: alertConfigurationAction.alertLevel.alertLevel.id },
          action: { id: alertConfigurationAction.action.action.id },
          threshold: { id: alertConfigurationAction.threshold.threshold.id },
          resolutionNotificationEnabled: alertConfigurationAction.resolutionNotificationEnabled,
          autoResolutionEnabled: alertConfigurationAction.autoResolutionEnabled
        };
      }),
      alertExemptTimes: alertConfigurationData.alertExemptTimes.map((item) => {
        return {
          startAtTime: item.startAtTime ? item.startAtTime : 0,
          endAtTime: item.endAtTime ? item.endAtTime : 0,
          monday: item.monday,
          tuesday: item.tuesday,
          wednesday: item.wednesday,
          thursday: item.thursday,
          friday: item.friday,
          saturday: item.saturday,
          sunday: item.sunday,
          allDay: (item.startAtTime ? item.startAtTime : 0) === 0 && (item.endAtTime ? item.endAtTime : 0) === (24 * 60 * 60)
        };
      })
    };

    this.setState({ alertConfiguration: null });

    EventConfigurationsService.add(alertConfiguration).then(response => {
      this.setState({
        alertConfiguration: response.eventConfiguration,
        alertConfigurationSaved: true
      });
    }).catch(error => {
      this.setState({
        localErrorMessage: i18next.t('messages.event-add-failure'),
        alertConfigurationSaved: false
      });
      console.error(error);
    });
  }

  render() {
    if (this.state.alertConfigurationSaved) {
      return (
          <Redirect to={{
            pathname: '/config/events',
            state: {
              successMessage: i18next.t('messages.event-saved-success')
            }
          }}/>
      );
    } else if (this.props.me) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div>
            <div className="row">
              <PageTitle title={ i18next.t('pages.event-configurations.add-header') }
                         backLinkWithParams={{
                           link: {
                             pathname: "/config/events",
                             search: backLinkSearch
                           }
                         }} />
            </div>

            {this.renderMessages()}

            <EventConfigurationForm onSubmit={this.handleSubmit.bind(this)}
                                    backLinkWithParams={{
                                      link: {
                                        pathname: "/config/events",
                                        search: backLinkSearch
                                      }
                                    }} />
          </div>
      );
    } else {
      return (
          <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }
}

export default EventConfigurationAdd;
